import React from 'react'
import { Field } from 'formik'
import { Form } from '_zari/core'

const IndicadorCompraFormGroup = ({ iEnabled, iValue, fIsSubmitting }) => {
  return (
    <Field name='flagCompra'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          disabled={!iEnabled || fIsSubmitting}
          checked={iValue}
          id='checkbox-flagCompra'
          label='COMPRAS'
        />
      )}
    </Field>
  )
}

export default React.memo(IndicadorCompraFormGroup)
